import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { fmtDateTime } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function LeadRemarks({ lead, onAdded }) {
  const [text, setText] = useState("");
  if (!lead) return null;
  const add = async () => {
    if (!text.trim()) return;
    try { await api.post(`/leads/${lead.id}/remarks`, { text }); setText(""); toast.success("Remark added"); onAdded(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const remarks = (lead.remarks || []).slice().reverse();
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 mt-4" data-testid="lead-remarks">
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-600 mb-3">
        <span>College visit: <b>{lead.college_visiting_date || "—"}</b></span>
        <span>Scholarship: <b>{lead.scholarship_status || "—"}</b></span>
        <span>Admission: <b>{lead.admission_status || "—"}</b></span>
        {lead.suggested_college_names?.length > 0 && <span>Suggested: <b>{lead.suggested_college_names.join(", ")}</b></span>}
      </div>
      <div className="font-heading font-semibold text-[#312E81] text-sm mb-2">Remarks</div>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Add a remark" data-testid="remark-input" />
      <Button size="sm" onClick={add} className="mt-2 bg-[#4F46E5] hover:bg-[#4338CA]" data-testid="remark-save">Add Remark</Button>
      <div className="space-y-2 mt-3">
        {remarks.map((r, i) => <div key={r.id || i} className="text-sm border-l-2 border-indigo-200 pl-2"><div className="text-slate-700 whitespace-pre-line">{r.text}</div><div className="text-[10px] text-slate-400">{r.by} · {fmtDateTime(r.at)}</div></div>)}
        {!remarks.length && <div className="text-xs text-slate-400">No remarks yet</div>}
      </div>
    </div>
  );
}
